"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'rest-cc' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign({}, defaultConfig, restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 61 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'rest-cc' });
    }
    ;
    /**
    * @typedef {Object} customerInformationClickContinueParams
    * @property {string} errorField - e-mail/name/etc.
    * @property {boolean} isError - Yes/no
    * @property {boolean} isNewCustomer - yes/no
    * @property {string} organizationId - string
    **/
    /**
     * Name: Customer Information > Click continue. Evid: 609.
     * Event description: Continue click on the Customer Information  page- with error type.
    
     * errorField - Type: string. Desc: e-mail/name/etc.
     *
     * isError - Type: bool. Desc: Yes/no
     *
     * isNewCustomer - Type: bool. Desc: yes/no
     *
     * organizationId - Type: string. Desc: string
     * @param {customerInformationClickContinueParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.customerInformationClickContinue = function (params) {
        return this.bi.log(__assign({ evid: 609 }, params));
    };
    /**
    * @typedef {Object} menuFilterOptionsParams
    * @property {string} organizationId - Could be string
    * @property {string} value - Click on which option (vegan, etc..). The result is a list with all the filters clicked. (Vegan, vegetarian, etc..)
    **/
    /**
     * Name: menu -> filter -> options. Evid: 620.
     * Event description: Click On some option into the filter menu.
    
     * organizationId - Type: string. Desc: Could be string
     *
     * value - Type: string. Desc: Click on which option (vegan, etc..). The result is a list with all the filters clicked. (Vegan, vegetarian, etc..)
     * @param {menuFilterOptionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.menuFilterOptions = function (params) {
        return this.bi.log(__assign({ evid: 620 }, params));
    };
    /**
    * @typedef {Object} callCenterEmptyStateParams
    * @property {string} errorType - Error
    * @property {GUID} msid - msid
    * @property {string} organizationId - String- Restaurant_ID
    **/
    /**
     * Name: Call center -> Empty state. Evid: 623.
     * Event description: CC opened via BO- No able to start (Don't accept payments, no Olo, etc.).
    
     * errorType - Type: string. Desc: Error
     *
     * msid - Type: guid. Desc: msid
     *
     * organizationId - Type: string. Desc: String- Restaurant_ID
     * @param {callCenterEmptyStateParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.callCenterEmptyState = function (params) {
        return this.bi.log(__assign({ evid: 623 }, params));
    };
    /**
    * @typedef {Object} addressInformationFillChangeAddressParams
    * @property {boolean} isInDeliveryArea - =Warning on address (Error)
    * @property {boolean} isNewAddress - yes/no
    * @property {string} organizationId - string
    **/
    /**
     * Name: Address Information > Fill/change Address. Evid: 611.
     * Event description: Fill/change Address.
    
     * isInDeliveryArea - Type: bool. Desc: =Warning on address (Error)
     *
     * isNewAddress - Type: bool. Desc: yes/no
     *
     * organizationId - Type: string. Desc: string
     * @param {addressInformationFillChangeAddressParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.addressInformationFillChangeAddress = function (params) {
        return this.bi.log(__assign({ evid: 611 }, params));
    };
    /**
    * @typedef {Object} phoneNumberClickContinueParams
    * @property {boolean} isError - Yes/no
    * @property {string} organizationId - Note that the field may be empty
    * @property {string} phoneError - If error, then the wrong phone number will be sent.
    **/
    /**
     * Name: Phone number > Click continue. Evid: 608.
     * Event description: Continue click on the first page- Phone number.
    
     * isError - Type: bool. Desc: Yes/no
     *
     * organizationId - Type: string. Desc: Note that the field may be empty
     *
     * phoneError - Type: string. Desc: If error, then the wrong phone number will be sent.
     * @param {phoneNumberClickContinueParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.phoneNumberClickContinue = function (params) {
        return this.bi.log(__assign({ evid: 608 }, params));
    };
    /**
    * @typedef {Object} sideMenuClickOnCustomerSidebarParams
    * @property {string} organizationId - Could be string
    * @property {string} value - Click on: Customer Info/Delivery type/Orders History)
    **/
    /**
     * Name: Side menu -> Click on Customer Sidebar. Evid: 618.
     * Event description: Click On Customer on Sidebar menu (One of the options), after clicking on Slider..
    
     * organizationId - Type: string. Desc: Could be string
     *
     * value - Type: string. Desc: Click on: Customer Info/Delivery type/Orders History)
     * @param {sideMenuClickOnCustomerSidebarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.sideMenuClickOnCustomerSidebar = function (params) {
        return this.bi.log(__assign({ evid: 618 }, params));
    };
    /**
    * @typedef {Object} menuFilterParams
    * @property {boolean} isOpen - is open after the click=1 (New State)
    * @property {string} organizationId - Could be string
    **/
    /**
     * Name: menu -> filter. Evid: 619.
     * Event description: Click On filter in the menu.
    
     * isOpen - Type: bool. Desc: is open after the click=1 (New State)
     *
     * organizationId - Type: string. Desc: Could be string
     * @param {menuFilterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.menuFilter = function (params) {
        return this.bi.log(__assign({ evid: 619 }, params));
    };
    /**
    * @typedef {Object} callCenterCartClickOnDishParams
    * @property {string} item_id - Dish ID
    * @property {string} item_name - Dish name
    * @property {string} organization_id - String- Restaurant_ID
    * @property {string} origin - Menu/Cart
    * @property {boolean} withFilter - is menu filtered= 1 (when clicking on dish)
    **/
    /**
     * Name: Click on dish. Evid: 605.
     * Event description: Click on Choose Cart (Side of the Menu)- Click on dish- In order to edit it..
    
     * item_id - Type: string. Desc: Dish ID
     *
     * item_name - Type: string. Desc: Dish name
     *
     * organization_id - Type: string. Desc: String- Restaurant_ID
     *
     * origin - Type: string. Desc: Menu/Cart
     *
     * withFilter - Type: bool. Desc: is menu filtered= 1 (when clicking on dish)
     * @param {callCenterCartClickOnDishParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.callCenterCartClickOnDish = function (params) {
        return this.bi.log(__assign({ evid: 605 }, params));
    };
    /**
    * @typedef {Object} submitOrderRequestParams
    * @property {GUID} idRequest - same value as next event
    * @property {GUID} msid - msid
    * @property {string} organizationId - Could be string
    **/
    /**
     * Name: submit order request. Evid: 624.
     * Event description: Click on submit order- request to server has been sent..
    
     * idRequest - Type: guid. Desc: same value as next event
     *
     * msid - Type: guid. Desc: msid
     *
     * organizationId - Type: string. Desc: Could be string
     * @param {submitOrderRequestParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.submitOrderRequest = function (params) {
        return this.bi.log(__assign({ evid: 624 }, params));
    };
    /**
    * @typedef {Object} navigationPageParams
    * @property {string} organizationId - Should be String
    * @property {string} pageName - will be sent when navigating between pages.
    **/
    /**
     * Name: navigation page. Evid: 613.
     * Event description: navigation page.
    
     * organizationId - Type: string. Desc: Should be String
     *
     * pageName - Type: string. Desc: will be sent when navigating between pages.
     * @param {navigationPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.navigationPage = function (params) {
        return this.bi.log(__assign({ evid: 613 }, params));
    };
    /**
    * @typedef {Object} addressInformationClickContinueParams
    * @property {string} deliveryType - Delivery/Pickup
    * @property {boolean} hasComment - yes/no
    * @property {string} organizationId - Should be String
    **/
    /**
     * Name: Address Information> Click continue. Evid: 612.
     * Event description: Continue click on the address Information- Error cannot be sent here..
    
     * deliveryType - Type: string. Desc: Delivery/Pickup
     *
     * hasComment - Type: bool. Desc: yes/no
     *
     * organizationId - Type: string. Desc: Should be String
     * @param {addressInformationClickContinueParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.addressInformationClickContinue = function (params) {
        return this.bi.log(__assign({ evid: 612 }, params));
    };
    /**
    * @typedef {Object} cancelOrderClickParams
    * @property {string} organizationId - New org_ID
    **/
    /**
     * Name: Cancel Order click. Evid: 615.
     * Event description: Cancel Order click- in some stage of the order.
    
     * organizationId - Type: string. Desc: New org_ID
     * @param {cancelOrderClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cancelOrderClick = function (params) {
        return this.bi.log(__assign({ evid: 615 }, params));
    };
    /**
    * @typedef {Object} callCenterCheckoutChooseCheckoutMethodParams
    * @property {string} checkout_method - Manually/PPD
    * @property {string} organization_id - String- Restaurant_ID
    **/
    /**
     * Name: Call center -> Checkout-> Choose Checkout Method. Evid: 604.
     * Event description: Click on Choose Checkout Method- Mannually/Pay per dish.
    
     * checkout_method - Type: string. Desc: Manually/PPD
     *
     * organization_id - Type: string. Desc: String- Restaurant_ID
     * @param {callCenterCheckoutChooseCheckoutMethodParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.callCenterCheckoutChooseCheckoutMethod = function (params) {
        return this.bi.log(__assign({ evid: 604 }, params));
    };
    /**
    * @typedef {Object} callCenterDummyEventParams
    * @property {string} jsonData - json string
    * @property {GUID} msid - msid
    * @property {string} organization_id - String- Restaurant_ID
    * @property {string} value - Test value
    **/
    /**
     * Name: Call center -> Dummy event. Evid: 601.
     * Event description: Dummy first event for testing- New project- CC.
    
     * jsonData - Type: string. Desc: json string
     *
     * msid - Type: guid. Desc: msid
     *
     * organization_id - Type: string. Desc: String- Restaurant_ID
     *
     * value - Type: string. Desc: Test value
     * @param {callCenterDummyEventParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.callCenterDummyEvent = function (params) {
        return this.bi.log(__assign({ evid: 601 }, params));
    };
    /**
    * @typedef {Object} addressInformationChangeDeliveryTypeParams
    * @property {string} deliveryType - Pickup/Delivery
    * @property {string} organizationId - string
    **/
    /**
     * Name: Address Information > Change Delivery type. Evid: 610.
     * Event description: Click delivery/pickup.
    
     * deliveryType - Type: string. Desc: Pickup/Delivery
     *
     * organizationId - Type: string. Desc: string
     * @param {addressInformationChangeDeliveryTypeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.addressInformationChangeDeliveryType = function (params) {
        return this.bi.log(__assign({ evid: 610 }, params));
    };
    /**
    * @typedef {Object} loadCallCenterParams
    * @property {string} organizationId - Note that the field may be empty
    **/
    /**
     * Name: Load Call center. Evid: 607.
     * Event description: Call center system loaded- Successfully.
    
     * organizationId - Type: string. Desc: Note that the field may be empty
     * @param {loadCallCenterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.loadCallCenter = function (params) {
        return this.bi.log(__assign({ evid: 607 }, params));
    };
    /**
    * @typedef {Object} callCenterCheckoutClickOnPaymentMethodSelectionParams
    * @property {string} organization_id - String- Restaurant_ID
    * @property {string} payment_index - In case of Split Payment- 0 is the first value.
    * @property {string} pmnt_method - Cash/credit/cibus/etc.
    **/
    /**
     * Name: Call center -> Checkout-> Click on Payment Method selection. Evid: 602.
     * Event description: Click on Payment Method selection.
    
     * organization_id - Type: string. Desc: String- Restaurant_ID
     *
     * payment_index - Type: string. Desc: In case of Split Payment- 0 is the first value.
     *
     * pmnt_method - Type: string. Desc: Cash/credit/cibus/etc.
     * @param {callCenterCheckoutClickOnPaymentMethodSelectionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.callCenterCheckoutClickOnPaymentMethodSelection = function (params) {
        return this.bi.log(__assign({ evid: 602 }, params));
    };
    /**
    * @typedef {Object} sideMenuClickParams
    * @property {string} menuId - menu Id
    * @property {string} menuName - Menu name
    * @property {string} organizationId - Could be string
    * @property {string} sectionId - Section ID
    * @property {string} sectionName - Section name
    **/
    /**
     * Name: Side menu -> Click. Evid: 617.
     * Event description: Click On Section/Menu on side Menu.
    
     * menuId - Type: string. Desc: menu Id
     *
     * menuName - Type: string. Desc: Menu name
     *
     * organizationId - Type: string. Desc: Could be string
     *
     * sectionId - Type: string. Desc: Section ID
     *
     * sectionName - Type: string. Desc: Section name
     * @param {sideMenuClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.sideMenuClick = function (params) {
        return this.bi.log(__assign({ evid: 617 }, params));
    };
    /**
    * @typedef {Object} hamburgerMenuClickParams
    * @property {string} organizationId - New org_ID
    **/
    /**
     * Name: Hamburger Menu click. Evid: 616.
     * Event description: Click on Hamburger Menu = Three lines on the left side when low-resolution screens.
    
     * organizationId - Type: string. Desc: New org_ID
     * @param {hamburgerMenuClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.hamburgerMenuClick = function (params) {
        return this.bi.log(__assign({ evid: 616 }, params));
    };
    /**
    * @typedef {Object} changeBranchParams
    * @property {string} oldOrganizationID - Old Org_ID
    * @property {string} organizationId - New org_ID
    **/
    /**
     * Name: Change branch. Evid: 614.
     * Event description: Change branch.
    
     * oldOrganizationID - Type: string. Desc: Old Org_ID
     *
     * organizationId - Type: string. Desc: New org_ID
     * @param {changeBranchParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeBranch = function (params) {
        return this.bi.log(__assign({ evid: 614 }, params));
    };
    /**
    * @typedef {Object} cartChangeDishAmountParams
    * @property {string} itemId - Dish ID
    * @property {string} itemName - Dish name
    * @property {number} newAmount - new dishes amount. 0 when clicking on x for removing all the entire dish.
    * @property {string} organizationId - String- Restaurant_ID
    **/
    /**
     * Name: Cart ->  change dish amount. Evid: 622.
     * Event description: Click on add (plus) dish from the Cart (Right side of the Menu).
    
     * itemId - Type: string. Desc: Dish ID
     *
     * itemName - Type: string. Desc: Dish name
     *
     * newAmount - Type: numeric. Desc: new dishes amount. 0 when clicking on x for removing all the entire dish.
     *
     * organizationId - Type: string. Desc: String- Restaurant_ID
     * @param {cartChangeDishAmountParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cartChangeDishAmount = function (params) {
        return this.bi.log(__assign({ evid: 622 }, params));
    };
    /**
    * @typedef {Object} submitOrderResponseParams
    * @property {string} currency - 3 letters currency
    * @property {number} deliveryCharges - delivery charges amount in cents (multiple by 100)
    * @property {string} errorDescription - if false, which error
    * @property {number} grandTotal - the total amount of the order multiple by 100 (in cents)
    * @property {GUID} idRequest - Same value as last event
    * @property {boolean} isSuccess - true/false
    * @property {GUID} msid - msid
    * @property {number} numDiscounts - num of discounts
    * @property {number} numItems - number of items in the cart
    * @property {string} orderId - Olo Order ID- use is with the server
    * @property {string} orderMethod - delivery / pickup
    * @property {string} organizationId - guid
    **/
    /**
     * Name: submit order response. Evid: 625.
     * Event description: User click on confirm order.
    
     * currency - Type: string. Desc: 3 letters currency
     *
     * deliveryCharges - Type: numeric. Desc: delivery charges amount in cents (multiple by 100)
     *
     * errorDescription - Type: string. Desc: if false, which error
     *
     * grandTotal - Type: numeric. Desc: the total amount of the order multiple by 100 (in cents)
     *
     * idRequest - Type: guid. Desc: Same value as last event
     *
     * isSuccess - Type: bool. Desc: true/false
     *
     * msid - Type: guid. Desc: msid
     *
     * numDiscounts - Type: numeric. Desc: num of discounts
     *
     * numItems - Type: numeric. Desc: number of items in the cart
     *
     * orderId - Type: string. Desc: Olo Order ID- use is with the server
     *
     * orderMethod - Type: string. Desc: delivery / pickup
     *
     * organizationId - Type: string. Desc: guid
     * @param {submitOrderResponseParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.submitOrderResponse = function (params) {
        return this.bi.log(__assign({ evid: 625 }, params));
    };
    /**
    * @typedef {Object} checkoutWarningParams
    * @property {string} errorType - Overpay/Underpay/etc.
    * @property {string} organizationId - Note that the field may be empty
    * @property {number} priceDiff - Difference in order to set payment without warning/error
    **/
    /**
     * Name: Checkout -> warning. Evid: 621.
     * Event description: Click on Place order- no success
    Optional reasons: Overpay/Underpay/etc..
    
     * errorType - Type: string. Desc: Overpay/Underpay/etc.
     *
     * organizationId - Type: string. Desc: Note that the field may be empty
     *
     * priceDiff - Type: numeric. Desc: Difference in order to set payment without warning/error
     * @param {checkoutWarningParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.checkoutWarning = function (params) {
        return this.bi.log(__assign({ evid: 621 }, params));
    };
    /**
    * @typedef {Object} callCenterDummyNameParams
    
    **/
    /**
     * Name: Call Center -> dummy-name. Evid: 600.
    
    
    
     * @param {callCenterDummyNameParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.callCenterDummyName = function (params) {
        return this.bi.log(__assign({ evid: 600 }, params));
    };
    /**
    * @typedef {Object} callCenterCheckoutClickOnRemovePaymentMethodParams
    * @property {number} amount - Price (Cancelled- Divide by 100 to use)
    * @property {string} organization_id - String- Restaurant_ID
    * @property {string} pmnt_method - Cash/credit/cibus/etc.
    **/
    /**
     * Name: Call center -> Checkout-> Click on remove payment method. Evid: 603.
     * Event description: Click on remove payment method- Split the bill removal (click on x).
    
     * amount - Type: numeric. Desc: Price (Cancelled- Divide by 100 to use)
     *
     * organization_id - Type: string. Desc: String- Restaurant_ID
     *
     * pmnt_method - Type: string. Desc: Cash/credit/cibus/etc.
     * @param {callCenterCheckoutClickOnRemovePaymentMethodParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.callCenterCheckoutClickOnRemovePaymentMethod = function (params) {
        return this.bi.log(__assign({ evid: 603 }, params));
    };
    /**
    * @typedef {Object} cannotLoadSystemParams
    * @property {string} organizationId - Note that the field may be empty
    * @property {string} type - Error type (Name, no permissions, etc.)
    **/
    /**
     * Name: Cannot load system. Evid: 606.
     * Event description: All sorts of logical errors when loading system (No permissions- Orders off, etc.).
    
     * organizationId - Type: string. Desc: Note that the field may be empty
     *
     * type - Type: string. Desc: Error type (Name, no permissions, etc.)
     * @param {cannotLoadSystemParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cannotLoadSystem = function (params) {
        return this.bi.log(__assign({ evid: 606 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
function getLoggerConf() {
    return {
        src: 61,
        endpoint: 'rest-cc'
    };
}
exports.getLoggerConf = getLoggerConf;
//# sourceMappingURL=index.js.map